module.exports = __webpack_public_path__ + "static/img/7.d394502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles/1/7.jpg
// module id = 16Kt
// module chunks = 0